module.exports = __webpack_public_path__ + "img/arc.edf239c6.svg";